import React from 'react';
import { PrismCode } from 'react-prism';
import Helmet from 'react-helmet';
import IconBoxExample from '../examples/IconBox';
const IconBoxExampleSource = require('!!raw-loader!../examples/IconBox');
export default class IconBoxPage extends React.Component {
    render() {
        return (<div>
                <Helmet title="IconBox"/>
                <h3>IconBox</h3>
                <div className="docs-example">
                    <IconBoxExample />
                </div>
                <pre>
                    <PrismCode className="language-jsx">{IconBoxExampleSource}</PrismCode>
                </pre>
            </div>);
    }
}
